<tr><th>{{ row.label }}</th><td class="text-center" v-for="item in rowData" :key="item.id"><pux-icon :icon="item.icon"></pux-icon></td></tr>